(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/oddsmind-chat/assets/javascripts/oddsmind-chat.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/oddsmind-chat/assets/javascripts/oddsmind-chat.js');
"use strict";


const _svs$components$oddse = svs.components.oddset.common.utils,
  getOddsetBetslipQueryString = _svs$components$oddse.getOddsetBetslipQueryString,
  getOddsetBetslipQueryStringCombo = _svs$components$oddse.getOddsetBetslipQueryStringCombo;
const navigateTo = svs.oddset_kambi.components.wapiIntegration.navigateTo;
const logger = svs.core.log.getLogger('oddset_kambi:components:oddsmind_chat');

const oddsmindBetslipPath = betData => {
  var _betData$coupon;
  const outcomeIds = betData === null || betData === void 0 || (_betData$coupon = betData.coupon) === null || _betData$coupon === void 0 ? void 0 : _betData$coupon.outcomeIds;
  if (outcomeIds !== null && outcomeIds !== void 0 && outcomeIds.length) {
    if ((betData === null || betData === void 0 ? void 0 : betData.source) === 'single') {
      return getOddsetBetslipQueryString(outcomeIds[0]);
    }
    if ((betData === null || betData === void 0 ? void 0 : betData.source) === 'combo') {
      return getOddsetBetslipQueryStringCombo(outcomeIds.join());
    }
  }
  if (betData !== null && betData !== void 0 && betData.fallbackUrl) {
    return betData.fallbackUrl;
  }
};
const oddsmindNavigate = betData => {
  const path = oddsmindBetslipPath(betData);
  if (path) {
    navigateTo(path);
  } else {
    logger.warn('Could not navigate to oddsmind recommended bet', betData);
  }
};
const toExport = {
  oddsmindNavigate
};
setGlobal('svs.oddset_kambi.components.oddsmind_chat', toExport);

 })(window);